<template lang="pug">
form(@submit.prevent="desconto")
  modal(:active="true", title="Confirmação", @close="close")
    div(slot="modal-body")
      p.text Você está
        span.text-bold &nbsp;solicitando defesa
        span &nbsp;de sua notificação/auto
        span.text-bold &nbsp;{{ `${current.numero}/${current.ano}` }}
      p.text Após confirmar não será possível reverter este processo.
        .form-group
          label.form-label(for="motivo") Motivo da defesa #[span.text-error *]
          textarea#motivo.form-input(
            v-model="defesa.motivo",
            rows="3",
            placeholder="Descreva o motivo para solicitar a defesa"
          )
        .form-group
          label.form-label(for="anexos") Anexos
          input#anexos.form-input(
            type="file",
            accept=".jpg,.jpeg,.png",
            multiple,
            @change="defesa.files = $event.target.files"
          )
    div(slot="modal-footer")
      a.btn.btn-link.text-error(@click="close", :disabled="uploading")
        i.fa.fa-close
        |
        | Cancelar
      button.btn.btn-primary(
        :disabled="!defesa.motivo || uploading",
        @click="desconto"
      )
        i.fa.fa-check
        |
        | Confirmar
</template>

<script>
import uploads from "@/api/uploads";
import toastErrors from "@/lib/errors/toastErrors";
import FileUpload from "@/lib/FileUpload";

export default {
  vuex: {
    docs: { state: ["current"], actions: ["fetchSolicitarDefesa"] },
  },
  data() {
    return {
      uploading: false,
      defesa: { motivo: "", files: [] },
    };
  },
  methods: {
    async uploadFiles(files = []) {
      this.uploading = true;
      try {
        const anexos = [];
        for (const file of files) {
          const { signedUrl } = await uploads.signedParams();
          const fileUpload = new FileUpload(signedUrl);
          const res = await fileUpload.upload({ file });
          anexos.push({
            file_info: res.currentTarget.response,
          });
        }
        return anexos;
      } catch (error) {
        toastErrors([error]);
        throw error; // Re-throw to handle in the calling method
      } finally {
        this.uploading = false;
      }
    },
    async desconto() {
      try {
        const anexos = await this.uploadFiles(this.defesa.files);
        await this.fetchSolicitarDefesa({ motivo: this.defesa.motivo, anexos });
        this.$toaster.success("Defesa enviada com sucesso.");
        this.close();
      } catch (e) {
        toastErrors([e]);
      }
    },
    close() {
      this.$router.back();
    },
  },
};
</script>
